<template>
  <div class="about">
    <my-navi activeIndex="13"></my-navi>
    <el-container>
      <el-header>
        <div style="display: flex; align-items: center;">
          <el-upload
            :on-change="loadFile"
            :before-upload="fileCheck"
            :show-file-list="false"
            accept=".txt"
          >
            <el-button slot="trigger" size="small" type="primary">加载库存报告</el-button>
          </el-upload>
          <el-tag v-if="filename" size="small" style="margin-left: 10px;" type="info">{{ filename }}</el-tag>
        </div>
        <el-select v-model="site" style="width: 100px; margin-left: 10px;" placeholder="选择站点">
          <el-option label="US" value="US"></el-option>
          <el-option label="CA" value="CA"></el-option>
          <el-option label="AU" value="AU"></el-option>
        </el-select>
        <el-input
          style="width: 70%; margin-left:10px"
          v-model="searchTerm"
          @keypress.enter.native="performSearch"
        ></el-input>
        <el-button
          style="margin-left: 20px; width: 5%;"
          type="primary"
          @click="performSearch"
          >搜索</el-button
        >
      </el-header>
      <el-main>
        <el-card style="margin-bottom: 20px;">
          <el-descriptions :column="1" border>
            <el-descriptions-item label="操作步骤">
              <ol>
                <li><strong>第一步：加载报告</strong> — 点击"加载库存报告"按钮上传txt格式的库存报告文件。</li>
                <li><strong>第二步：选择站点</strong> — 选择目标站点（US/CA/AU），不同站点影响调价时的汇率计算。</li>
                <li><strong>第三步：搜索商品</strong> — 在搜索框输入关键词，按回车或点击"搜索"按钮，匹配SKU中包含该关键词的商品。</li>
                <li><strong>第四步：批量操作</strong> — 可执行"下架"（库存设为0）、"保留1"（库存设为1）或"调价"（输入浮动价格后点击调价）。</li>
                <li><strong>第五步：加入结果队列</strong> — 点击"加入结果队列>>"将当前搜索结果添加到右侧结果列表。</li>
                <li><strong>第六步：导出文件</strong> — 在右侧列表确认无误后，点击"导出TXT"生成亚马逊批量调价模板文件。</li>
              </ol>
            </el-descriptions-item>
            <el-descriptions-item label="站点汇率">
              <ul>
                <li>US站点：汇率 1.00</li>
                <li>CA站点：汇率 1.42</li>
                <li>AU站点：汇率 1.44</li>
              </ul>
            </el-descriptions-item>
            <el-descriptions-item label="调价公式">
              最终价格 = 原价 + 浮动价格 × 汇率（向上取整）<br/>
              例如：原价$100，浮动$10，选择CA站点（汇率1.42）<br/>
              最终价格 = 100 + 10 × 1.42 = 114.2 → 向上取整为 115
            </el-descriptions-item>
            <el-descriptions-item label="功能说明">
              <ul>
                <li><strong>清空</strong> — 清空当前搜索结果，重置价格浮动输入框。</li>
                <li><strong>下架</strong> — 将搜索结果中所有商品的库存数量设为0。</li>
                <li><strong>保留1</strong> — 将搜索结果中所有商品的库存数量设为1。</li>
                <li><strong>调价</strong> — 根据输入的浮动价格和当前站点汇率，重新计算商品价格。</li>
                <li><strong>加入结果队列</strong> — 将左侧搜索结果添加到右侧结果列表，准备导出。</li>
                <li><strong>撤回到上一次</strong> — 撤销上一次加入结果队列的操作。</li>
                <li><strong>导出TXT</strong> — 将右侧结果列表导出为亚马逊批量调价模板文件。</li>
              </ul>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>
        <el-row type="flex" justify="space-around">
          <el-col :span="11">
            <el-row
              type="flex"
              justify="space-between"
              style="padding-bottom: 20px;"
            >
              <div>
                <el-button @click="clearSerchresult">清空</el-button>
                <el-button style="margin-left: 10px;" @click="outOfStock()"
                  >下架</el-button
                >
                <el-button style="margin-left: 10px;" @click="outOfStock(1)"
                  >保留1</el-button
                >
                <el-input
                  v-model="priceFlow"
                  type="number"
                  style="width: 30%; margin-left: 10px;"
                  placeholder="价格浮动"
                  @keypress.enter.native="priceFlowAction"
                ></el-input>
                <el-button
                  :disabled="priceFlowDisable"
                  type="primary"
                  @click="priceFlowAction"
                  >调价</el-button
                >
              </div>
              <div>
                <el-button style="margin-left: 10px;" @click="pushToResult"
                  >加入结果队列>></el-button
                >
              </div>
            </el-row>
            <el-row>
              <el-table :data="serchData">
                <el-table-column prop="sku" label="SKU"></el-table-column>
                <el-table-column
                  prop="price"
                  label="价格"
                  width="200"
                ></el-table-column>
                <el-table-column label="数量" width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.quantity"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      @click="searchDataDeleteHandle(scope.$index, scope.row)"
                    >
                      删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-col>
          <el-col :span="11">
            <el-row
              type="flex"
              justify="space-between"
              style="padding-bottom: 20px;"
            >
              <el-button @click="pushBack">撤回到上一次</el-button>
              <el-button type="primary" @click="outPutText">导出TXT</el-button>
            </el-row>
            <el-row>
              <el-table :data="finalData" :row-style="markDistrict">
                <el-table-column prop="sku" label="SKU"></el-table-column>
                <el-table-column
                  prop="price"
                  label="价格"
                  width="200"
                ></el-table-column>
                <el-table-column
                  prop="quantity"
                  label="数量"
                  width="200"
                ></el-table-column>
                <el-table-column label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      @click="finalDataDeleteHandle(scope.$index, scope.row)"
                    >
                      删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
// import axios from 'axios';
export default {
  data() {
    return {
      fileContent: null,
      searchTerm: "",
      serchData: [],
      tempData: [],
      finalData: [],
      priceFlow: "",
      priceFlowDisable: false,
      filename: "",
      //分区flag
      districtFlag: 0,
      //站点选择
      site: "US",
      //汇率配置
      exchangeRates: {
        US: 1,
        CA: 1.42,
        AU: 1.44
      }
    };
  },
  methods: {
    loadFile(file) {
      const isText = file.type === "text/plain" || file.name.endsWith(".txt");
      if (!isText) return;
      this.filename = file.raw.name;
      this.readFileContent(file);
    },
    fileCheck(file) {
      const isText = file.type === "text/plain" || file.name.endsWith(".txt");
      if (!isText) {
        this.$message.error("只能上传文本文件 (.txt)");
      }
      return false;
    },
    readFileContent(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.fileContent = e.target.result;
        this.$message.success("文件内容已加载");
      };

      reader.onerror = () => {
        this.$message.error("文件读取失败");
      };
      reader.readAsText(file.raw);
    },
    parseLine(line) {
      const parts = line.split("\t");
      // 确保有三部分数据
      if (parts.length < 3) return null;
      const sku = parts[0].trim();
      const pricePart = parts[2].trim();
      const quantityPart = parts[3].trim();
      // 转换价格（支持整数和小数）
      let price;
      // 尝试转换为浮点数
      price = parseFloat(pricePart);
      // 如果转换失败，尝试移除逗号后再转换
      if (isNaN(price)) {
        const cleanedPrice = pricePart.replace(/,/g, "");
        price = parseFloat(cleanedPrice);
      }
      if (isNaN(price)) {
        console.warn(`价格格式不符合预期: ${pricePart}`);
        return null;
      }
      // 转换数量
      const quantity = parseInt(quantityPart, 10);
      if (isNaN(quantity)) {
        console.warn(`数量格式不符合预期: ${quantityPart}`);
        return null;
      }
      return {
        sku,
        quantity,
        price,
        rawLine: line.trim()
      }; /*  */
    },
    performSearch() {
      if (!this.fileContent || !this.searchTerm) {
        this.$message({
          duration: 5000,
          type: "error",
          message: "未加载库存报告或未填写搜索词",
          customClass: "big-font-size"
        });
        return;
      }

      const results = [];
      const lines = this.fileContent.split("\n");

      lines.forEach(line => {
        let sku = line.split("\t")[0];
        if (sku.toLowerCase().includes(this.searchTerm.toLowerCase())) {
          const parsed = this.parseLine(line);
          if (parsed) results.push(parsed);
        }
      });
      this.serchData = results;
      this.priceFlowDisable = false;
    },
    clearSerchresult() {
      this.serchData = [];
      this.priceFlow = "";
      this.priceFlowDisable = false;
    },
    outOfStock(qty = 0) {
      let newAry = [];
      this.serchData.forEach(item => {
        let temp = {
          ...item
        };
        temp.quantity = qty;
        newAry.push(temp);
      });
      this.serchData = newAry;
    },
    priceFlowAction() {
      if (this.priceFlow == "") return;
      this.priceFlowDisable = true;
      const rate = this.exchangeRates[this.site];
      let newAry = [];
      this.serchData.forEach(item => {
        let temp = {
          ...item
        };
        // 根据站点计算价格：原价 + 浮动价格 * 汇率
        temp.price = Math.ceil(parseFloat(temp.price) + parseFloat(this.priceFlow) * rate);
        newAry.push(temp);
      });
      this.serchData = newAry;
    },
    pushBack() {
      if (this.finalData.length != this.tempData.length) {
        this.districtFlag -= 1;
      }
      this.finalData = [...this.tempData];
    },
    pushToResult() {
      if (this.serchData.length == 0) return;
      this.tempData = [...this.finalData];
      this.serchData.forEach(item => {
        let temp = {
          ...item
        };
        temp.flag = parseInt(this.districtFlag.toString());
        this.finalData.push(temp);
      });
      this.districtFlag += 1;
      this.clearSerchresult();
    },
    outPutText() {
      if (this.finalData.length == 0) return;
      let context =
        "sku\tprice\tminimum-seller-allowed-price\tmaximum-seller-allowed-price\tquantity\thandling-time\tfulfillment-channel\n";
      this.finalData.forEach(item => {
        let sku_str = item.sku + "\t";
        let price_str = item.price + "\t";
        let minprice_str = (parseFloat(item.price) / 2).toString() + "\t";
        let maxprice_str = (parseFloat(item.price) + 1000).toString() + "\t";
        let qty_str = item.quantity + "\t";
        let block_str = "\t\t\n";
        context +=
          sku_str +
          price_str +
          minprice_str +
          maxprice_str +
          qty_str +
          block_str;
      });
      const blob = new Blob([context], {
        type: "text/plain"
      });
      // 创建下载URL
      const url = URL.createObjectURL(blob);
      // 创建虚拟下载链接
      const link = document.createElement("a");
      link.href = url;
      link.download = "下架调价.txt";
      link.style.display = "none";

      // 添加到DOM
      document.body.appendChild(link);

      // 触发下载
      link.click();
    },
    searchDataDeleteHandle(index, row) {
      this.serchData.splice(index, 1);
    },
    finalDataDeleteHandle(index, row) {
      this.finalData.splice(index, 1);
      if (this.finalData.length == this.tempData.length) {
        this.districtFlag -= 1;
      }
    },
    markDistrict({ row, index }) {
      let style = {};
      if (row.flag % 2 == 0) {
        style.backgroundColor = "white";
      } else {
        style.backgroundColor = "#dddddd";
      }
      return style;
    }
  }
};
</script>

<style>
.big-font-size {
  font-size: 30px !important;
}
</style>
